import React from 'react';

export const CheckIcon = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 256 256" aria-hidden="true">
        <polyline
            points="40 144 96 200 224 72"
            fill="none"
            stroke="rgb(22,163,74)"
            strokeWidth="20"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
